// extracted by mini-css-extract-plugin
export default {"fullWidth":"TicketStatusBadge_fullWidth__fme6Y","redeemed":"TicketStatusBadge_redeemed__eino5","transferred":"TicketStatusBadge_transferred__zMAsh"};